import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const th = {
  fontSize: 12,
  fontWeight: 600,
  padding: '8px 10px',
  textAlign: 'left',
  background: '#f8fafc',
  borderBottom: '2px solid #e2e8f0',
};

const td = {
  fontSize: 12,
  padding: '7px 10px',
  borderBottom: '1px solid #e2e8f0',
};

const thR = { ...th, textAlign: 'right' };
const tdR = { ...td, textAlign: 'right' };

export default function BucketsTab({
  buckets, totalBktMkt, totalBktMat, totalBktHrs, totalBktLabor,
  totalBktCost, totalBktSell, st, tier, margin, C, fmt, fmtHrs, pct,
}) {
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ ...card, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: 13 }}>
          <strong>{buckets.length}</strong> bucket line item{buckets.length !== 1 ? 's' : ''}
        </div>
        <div style={{ fontSize: 12, color: '#64748b' }}>
          Starter: <strong style={{ color: C.blue || '#2563eb' }}>{st || '--'}</strong>
          {tier && (
            <span style={{ marginLeft: 12 }}>
              Tier: <strong>{tier}</strong>
            </span>
          )}
        </div>
      </div>

      {/* Table */}
      <div style={{ ...card, padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Tag</th>
                <th style={th}>HP</th>
                <th style={th}>NEMA</th>
                <th style={thR}>Market</th>
                <th style={thR}>Material</th>
                <th style={thR}>Hours</th>
                <th style={thR}>Labor</th>
                <th style={thR}>Total Cost</th>
                <th style={thR}>Sell Price</th>
                <th style={thR}>GP</th>
              </tr>
            </thead>
            <tbody>
              {buckets.map((b, i) => {
                // App.jsx populates buckets with these exact field names —
                // earlier the table used the wrong keys (nema / mkt / labor /
                // cost) which is why per-row showed "--" and $0 while the
                // totals (which read App.jsx state directly) worked.
                const nema = b.nemaSize ?? b.nema;
                const mkt = b.mktP ?? b.mkt;
                const labor = b.laborCost ?? b.labor;
                const cost = b.totalCost ?? b.cost;
                const gp = b.gp ?? ((b.sell || 0) - (cost || 0));
                const good = b.sell <= (mkt || Infinity);
                return (
                  <tr
                    key={i}
                    style={{
                      background: i % 2 === 0 ? '#fff' : '#fafbfc',
                    }}
                  >
                    <td style={{ ...td, fontWeight: 600 }}>{b.tag || '--'}</td>
                    <td style={td}>{b.hp}</td>
                    <td style={td}>{nema ?? '--'}</td>
                    <td style={tdR}>{mkt ? fmt(mkt) : '--'}</td>
                    <td style={tdR}>{fmt(b.mat || 0)}</td>
                    <td style={tdR}>{fmtHrs(b.hrs || 0)}</td>
                    <td style={tdR}>{fmt(labor || 0)}</td>
                    <td style={tdR}>{fmt(cost || 0)}</td>
                    <td
                      style={{
                        ...tdR,
                        fontWeight: 600,
                        color: good ? (C.green || '#16a34a') : (C.red || '#ef4444'),
                      }}
                    >
                      {fmt(b.sell || 0)}
                    </td>
                    <td
                      style={{
                        ...tdR,
                        color: gp >= 0 ? (C.green || '#16a34a') : (C.red || '#ef4444'),
                      }}
                    >
                      {fmt(gp)}
                    </td>
                  </tr>
                );
              })}
              {buckets.length === 0 && (
                <tr>
                  <td colSpan={10} style={{ ...td, textAlign: 'center', color: '#94a3b8', padding: 24 }}>
                    No bucket items to display.
                  </td>
                </tr>
              )}
            </tbody>
            {buckets.length > 0 && (
              <tfoot>
                <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
                  <td style={{ ...td, borderTop: '2px solid #e2e8f0' }} colSpan={3}>Totals</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmt(totalBktMkt || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmt(totalBktMat || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmtHrs(totalBktHrs || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmt(totalBktLabor || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmt(totalBktCost || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0', color: C.blue || '#2563eb' }}>{fmt(totalBktSell || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>
                    {fmt((totalBktSell || 0) - (totalBktCost || 0))}
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    </div>
  );
}
